export default {
    // 通用提示后缀, 减少重复代码
    common: {
        server_error: 'Service anomaly',
        cancel: 'cancel',
        ok: 'ok',
        preview: 'view',
        editor: 'editor',
        export: 'export',
        action: 'operation',
        empty: 'No data available for the time being',
        close: 'close',
        update: 'create/update',
        please_enter: 'please enter',
        delete: 'delete',
        add: 'add',
        save: 'save',
        Please_enter: 'Please enter',
        Submitted_successfully: 'Submitted successfully',
        Submission_failed: 'Submission failed',
        Successful_joining: 'Successful joining',
        Failed_to_join: 'Failed to join',
        Language_switch_successful: 'Language switch successful',
        added_to_the_attachment: 'It has been added to the attachment',
        Execution_exception: 'Execution exception',
        Deletion_failed: 'Deletion failed',
        System_prompt: 'System prompt',
        sure_delete_conversation: 'Are you sure you want to delete this conversation?',
        Modification_successful: 'Modification successful',
        Modification_failed: 'Modification failed',
        Please_enter_question: 'Please enter your question',
        Thinking: 'Thinking...',
        Service_request_exception: 'Service request exception',
        No_permission_operation: "Sorry, you don't have the permission for this operation",
    },
    status: {
        unanalysis: 'unanalysis',
        analyzing: 'analyzing',
        reanalyzing: 'reanalyzing',
        analysis_completed: 'analysis completed',
        analysis_error: 'analysis error',
        Invoke_the_tool: 'Invoke the tool',
        Tool_thinking_results: 'Tool thinking results',
        reanalysis_error: 'reanalysis_error',
        reviewed: 'Reviewed',
        unreviewed: 'Pending Review',
    },
    login: {
        welcome: 'Welcome~',
        login: 'Login',
        logout: 'Log out',
        phone: 'Username',
        password: 'Password',
        picture_code: 'Graphic verification code',
        sms_code: 'SMS verification code',
        confirm_password: 'Confirm password',
        new_password: 'New Password',
        confirm_new_password: 'Confirm New Password',
        change_password: 'Change Password',
        change_password_success: 'Password changed successfully',
        password_not_match: 'Passwords do not match',
        login_failure: 'Login failed',
        login_success: 'Login successful',
        enter_mobile: 'Please enter username',
        enter_password: 'Please enter password',
        enter_graphic: 'Please enter graphic verification code',
        enter_sms: 'Please enter SMS verify code',
        please_enter: 'Please enter',
        click_refresh: 'Click "Refresh"',
        sms_login: 'Verification code login',
        password_login: 'Password login',
        get_sms: 'Get verify code',
        forget_password: 'Forget the password',
        have_no_account: "Don't have an account yet? Go to ",
        register: 'Register',
        Visitor_login: 'Visitor login',
        rights_reserved: 'All rights reserved',
        retrieve_password: 'Retrieve password',
        update_password: 'Change password',
        solve_with_ai: 'Solve pathological problems with AI technology',
        highlights: 'Multi-scale analysis, multi-algorithm compatibility, multi-scale feature recording, and report organization and generation',
        new_password: 'New password',
        enter_new_password: 'Please enter New password',
        enter_confirm_password: 'Please enter Confirm password',

    },
    home: {
        Pathological_system: "Pathological AI reporting system",
        WSI_image: 'WSI image',
        Pathological_image: 'Pathological image',
        Ai_Assistant: 'Ai Assistant',
        Please_WSI_image: 'Please select the WSI image',
        you_generate_AI_reports: 'You can directly view the images for analysis and generate AI reports',
        zoom: 'Zoom:',
        Pixel_size: 'Pixel size',
        Pixel: 'Pixel',
        Viewport: 'Viewport',
        Business_serial_number: 'Business serial number:',
        Status: 'Status:',
        File_name: 'File name:',
        Select_reanalyze_it: 'Select the prompt word and reanalyze it',
        Reanalyze: 'Reanalyze',
        Hide: 'Hide',
        Display: 'Display',
        Key_area: 'Key area',
        Key_discovery: 'Key discovery',
        Detailed_discovery: 'Detailed discovery',
        A_further_summary: 'A further magnified summary',
        Return_to_analysis: 'Return to the overall analysis',
        Display_all_paths: 'Display all paths',
        Click_on_the_colored: '(Click on the colored areas in WSI to view the area analysis)',
        Key_path: 'Key path',
        Path_summary: 'Path summary',
        Path_analysis: 'Path analysis',
        Magnification: 'Magnification',
        Join_the_report: 'Join the report',
        Join_AI_conversations: 'Join AI conversations',
        zoom_in: 'Zoom in',
        zoom_out: 'Zoom out',
        Refresh: 'Refresh',
        Full_screen: 'Full screen',
        Fold_all: 'Fold all',
        Fully_unfold: 'Fully unfold',
        Adapt_to_the_screen: 'Adapt to the screen',
        Unfocus: 'Unfocus',
        Create_a_new_conversation: 'Create a new conversation',
        View_historical_conversations: 'View historical conversations',
        Refresh_the_conversation: 'Refresh the conversation',
        your_assistant: "Hi, I'm your assistant! After selecting a pathology report, you can start a conversation with the AI assistant. Come and give it a try!",
        Please_enter_new_name: 'Please enter the new name',
        Current: 'Current',
        Release_add_attachments: 'Release the mouse to add attachments',
        Input_message: 'Input message...',
        No_attachment: 'No attachment for the time being',
        right_click_add_tile: 'You can right-click in the SVS viewer to add a tile',
        Attachment: 'Attachment',
        Clear: 'Clear',
        Press_Enter_to_send: 'Press Enter to send a message and Shift + Enter to wrap a new line',
        Layer_node: 'Layer node',
        // Tab titles
        Overall_analysis: 'Overall Analysis',
        Path_analysis: 'Path Analysis',
        Tree_analysis: 'Tree Analysis',
        Review_scoring: 'Review Scoring',
        Microscopic_findings: 'Microscopic Findings',
        // Review scoring
        Score_roi_selection: 'RoI Selection Accuracy',
        Score_roi_selection_desc: 'Evaluate accuracy of selected regions of interest (0-5)',
        Score_roi_summary: 'RoI Summary Quality',
        Score_roi_summary_desc: 'Evaluate quality of critical paths analysis',
        Score_slide_diagnosis: 'Slide-level Diagnosis',
        Score_slide_diagnosis_desc: 'Evaluate quality of microscopic findings diagnosis',
        Review_comment: 'Review Comment',
        Review_comment_placeholder: 'Enter review comment (optional)',
        Submit_review: 'Submit Review',
        Review_submit_success: 'Review submitted successfully',
        Review_submit_failed: 'Failed to submit review',
        Please_score_roi_selection: 'Please score RoI Selection Accuracy',
        Please_score_roi_summary: 'Please score RoI Summary Quality',
        Please_score_slide_diagnosis: 'Please score Slide-level Diagnosis',
    },
    prompt: {
        prompt_word_config: 'prompt word configuration',
        system_prompt: 'system prompt word',
        custom_prompt: 'custom prompt words',
        prompt_search: 'Please enter the name of the prompt word or the organ to which it belongs to search',
        prompt_name: 'prompt word name',
        organ_which: 'organ to which',
        last_updated: 'last updated time',
        preview_prompt: 'check the WSI prompt words',
        sys_desc: 'systematic description',
        terminology_diagnostic: 'terminology and diagnostic criteria',
        config_prompt_word_description: 'The directory hierarchy (descriptors, diagnosticers, rag_agents, summarizers) currently does not support direct configuration of prompt words such as "Q&A", "systematic description", and "terminology diagnostic benchmark". To configure the above prompt words for it, you need to first create or select a specific configuration item in this directory, and then set the prompt words in that configuration item.',
        prompt_update_tip: 'This operation will initialize or update the prompt word for this organ type for you. If you already have a custom prompt word for this organ, the system will overwrite the existing content. Please operate with caution.',
        edit_prompt: 'edit the WSI prompt word',
        report_preview: 'preview of pathological analysis report',
        report_number: 'report number',
        regenerate_PDF: 'regenerate the PDF',
        report_PDF_loading: 'The PDF of the pathological report is being generated',
        file_name: 'file name',
        pdf_error: 'The PDF generation failed. Please try again later!',
        pdf_reload: 'reload',
        analysis_path_select: 'analysis of path selection',
        pdf_selected: 'selected',
        analysis_path: 'analysis path',
        unit: ' ',//a
        total: 'total ',
        tile: 'tile',
        selected: 'selected',
        include: 'Included',
        remove_pdf: 'remove from PDF',
        join_pdf: 'join PDF',
        remove_all: 'remove',
        unit_times: 'times',
        magnify: 'magnify',
        depth: 'depth',
        sequence: 'sequence',
    },
    slice: {
        Slice_analysis_list: 'Slice analysis list',
        Organ_name: 'Organ name',
        File_name: 'File name',
        WSI_status: 'WSI status',
        Review_status: 'Review status',
        Batch_analysis: 'Batch analysis',
        Submit_for_analysis: 'Submit for analysis',
        Reset: 'Reset',
        Selected: 'Selected',
        One_piece_data: ' piece of data',
        View_the_report: 'View the report',
        For_more_details: 'For more details',
        Organ: 'Organ',
        Status: 'Status',
        Load_image: 'Load image',
        Load_result: 'Load result',
        Prompt_word: 'Prompt word',
        Upload_time: 'Upload time',
        Operation: 'Operation',
        Search_image_ID: 'Search for image ID',
    }
}